import React, { useState } from 'react'
import { Form } from 'semantic-ui-react'
import { FormErrorHeader } from '../generic/form-error-header'
import { InputField } from '../generic/input-field';
import { SubmitButton } from '../generic/submit-button';
import { AuthenticationState } from '../../model/state/authentication-state';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { CreateCompteBeneficiaireBody } from '../../model/dto/body/create-compte-beneficiaires-body';
import { investmentService } from '../../services/investment-service';
import { SimpleButton } from '../generic/simple-button';
import { CreateCompteBeneficiaireResponse } from '../../model/dto/response';
import InformationBandeau from '../generic/information-bandeau/information-bandeau';

type Props = {
    onSkipAction?: () => void
}

type FieldData = {
    value?: any,
    name?: string,
    isValid?: boolean,
    key?: string
};
    
type FormData = {
    accountName: FieldData,
    iban: FieldData
}

export default function CreateCompteBeneficiairesForm({onSkipAction}:Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
    const [form, setForm] = useState<FormData>({
            accountName: {value: '', name: 'accountName', isValid: true},
            iban: {value: '', name: 'iban', isValid: true}
        }) 
    const [isFormError, setIsFormError] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName?: string,
    isValid?: boolean
    ): void => {
    const fieldValue: string = e.target.value;
    const newField: FieldData = {
        [fieldName!]: { value: fieldValue, name: fieldName!, isValid: isValid },
    };

    setForm({ ...form, ...newField });
    setIsFormError(false);
    };
    
    const regexName = /^(?!.*[&,'/]).{1,50}$/
    const validateAccountName = (value: string) => {
        return regexName.test(value)
    }

    const regexIban = /^[A-Z]{2}\d{2}[A-Z0-9]{23}$/i
    const validateIban = (value: string) => {
        return regexIban.test(value)
    }
    const errorNameMessage = "Certains charactères ne sont pas autorisés et/ou la saisie dépasse les 50 charactères"
    const errorIbanMessage = "Merci de renseigner votre IBAN à 27 caractères alphanumériques sans espace"

    const body: CreateCompteBeneficiaireBody = {
        Name: form.accountName.value,
        Iban: form.iban.value
    }

    const isFormValid = ():boolean => {
        return validateAccountName(form.accountName.value) && validateIban(form.iban.value)
    }
     const onFormNotValid = (): void => {
        setIsFormError(true)
    }

    const onActionSuccess = (response: CreateCompteBeneficiaireResponse) => {
        if(response.IsTraitementOk){
            if(response.RedirectUrl)
            return window.location.href = response.RedirectUrl
        }
    }

  return (
    <Form>
        <FormErrorHeader
                message="Veuillez corriger les champs en erreur"
                displayed={isFormError}
        />
        <InformationBandeau 
        type="information"
        icon={{name:'info circle', size:"big", color:"blue"}}
        message="Afin que ce compte puisse être utilisé pour vos futurs retraits, il vous faudra valider la procédure de vérification qui suivra après avoir cliqué sur le bouton valider de ce formulaire. Vous pourrez suivre l'état du compte en le retrouvant parmi la liste de vos comptes bancaires."
        />
        <Form.Field width={16}>
            <InputField 
                data={form.accountName}
                label="Nom donné au compte"
                onChange={handleInputChange}
                validateField = {validateAccountName}
                error={errorNameMessage}
                submitted={formSubmitted}
            />
        </Form.Field>
        <Form.Field width={16}>
            <InputField 
                data={form.iban}
                label="IBAN"
                onChange={handleInputChange}
                error={errorIbanMessage}
                validateField = {validateIban}
                submitted={formSubmitted}
            />
        </Form.Field>
        <div style={{marginTop: 20, display: 'flex'}}>
            <SubmitButton 
                data={body}
                label="Valider"
                onPreSubmit={() => {setFormSubmitted(true)}}
                action={() => investmentService.createCompteBeneficiaire(body, loginProps.user?.UserId ,loginProps?.oauth)}
                validateForm={isFormValid}
                onFormNotValid={onFormNotValid}
                onActionSuccess={onActionSuccess}
            />
            <SimpleButton
                label={"Annuler"}
                onClick={onSkipAction}
            />
        </div>
    </Form>
  )
}
